import { BrowserRouter } from 'react-router-dom';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { Provider } from 'react-redux';

import App from './App';
import { AlertsProvider } from './components/shared/Alerts/alertsService';
import { store } from './redux';
import { ConfirmDialogContextProvider } from './contexts/ConfirmDialog';
import { GoogleMapsProvider } from './components/shared/map/GoogleMapsLoader';

const AppWrapper = () => {
  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <AlertsProvider>
          <BrowserRouter>
            <Provider store={store}>
              <GoogleMapsProvider apiKeyType="scheduler">
                <ConfirmDialogContextProvider>
                  <App />
                </ConfirmDialogContextProvider>
              </GoogleMapsProvider>
            </Provider>
          </BrowserRouter>
        </AlertsProvider>
      </DndProvider>
    </>
  );
};

export default AppWrapper;
